import isSuperAdmin from "@/functional/permissions/isSuperAdmin";

export default (userPermissions: string[], permissions: string[]): boolean => {
  // Check that a user has all the input permissions (or is a super-admin)
  return (
    isSuperAdmin(userPermissions) ||
    permissions.every((p) => userPermissions.includes(p))
  );
};
